import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/sleek";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) {
    return (
      <div className="mx-auto max-w-[800px] px-6 py-32 text-center">
        <div className="font-display text-3xl">Post not found.</div>
        <Link to="/blog" className="underline mt-4 inline-block">Back to journal</Link>
      </div>
    );
  }
  if (!post) return <div className="mx-auto max-w-[800px] px-6 py-32 text-center text-zinc-500">Loading…</div>;

  return (
    <article className="mx-auto max-w-[820px] px-6 md:px-0 py-20 md:py-28">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-950"><ArrowLeft size={14} /> Back to journal</Link>
      <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 mt-10">{post.tags.join(" · ")} · {post.date}</div>
      <h1 className="font-display text-4xl md:text-6xl font-light tracking-tight mt-4 leading-[1.05]">{post.title}</h1>
      <div className="text-zinc-500 text-sm mt-4">By {post.author}</div>
      <img src={post.image} alt={post.title} className="w-full aspect-[16/9] object-cover mt-10" />
      <div className="prose prose-zinc max-w-none mt-10 text-zinc-800 leading-relaxed text-lg whitespace-pre-wrap">
        {post.content}
      </div>
    </article>
  );
}
